import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {MsalProvider} from '@azure/msal-react';
import {msalInstance} from '@/helpers/Auth/authService';
import {AuthContext} from '@/context/Auth/AuthContext';
import {useAuth} from '@/hooks/useAuth';

export const AuthProvider = ({children}) => {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthContextBridge>{children}</AuthContextBridge>
    </MsalProvider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

const AuthContextBridge = ({children}) => {
  const {
    isReady,
    isAuthenticated,
    claims,
    account,
    signInWithRedirect,
    handleLogin,
    signOut
  } = useAuth();

  const value = useMemo(
    () => ({
      isReady,
      isAuthenticated,
      authState: {accessToken: {claims}},
      account,
      claims,
      signInWithRedirect,
      handleLogin,
      signOut
    }),
    [
      isReady,
      isAuthenticated,
      claims,
      account,
      signInWithRedirect,
      handleLogin,
      signOut
    ]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthContextBridge.propTypes = {
  children: PropTypes.node.isRequired
};
